import React, { useEffect, useState } from "react";
import InfoBox from "common-ui-components/components/info-box/InfoBox";
import DonutChart from "common-ui-components/components/donut-chart/DonutChart";
import StatTiles from "common-ui-components/components/stat-tiles/StatTiles";
import API from "common-ui-components/components/utils/API";
import styles from "./OverviewCards.module.css";

const DeviceScanSummary = ({ successCount = 0, failedCount = 0, loading, onViewAll }) => {
  const [failedScans, setFailedScans] = useState([]);
  const success = Number(successCount) || 0;
  const failed = Number(failedCount) || 0;
  const total = success + failed;
  const percent = total ? Math.round((success / total) * 100) : 0;

  useEffect(() => {
    const getFailedScans = async () => {
      try {
        const response = await API.post("/devices/get-scan?page=0&size=10", {
          columns: [],
          sort: {},
          search: [],
          filter: [{ column: "status", filterValue: ["Failed"] }],
        });

        if (response?.status?.success) {
          setFailedScans((response?.body?.result || []).slice(0, 3));
        }
      } catch (error) {
        console.error("Error fetching failed scans: ", error);
      }
    };

    getFailedScans();
  }, []);

  return (
    <InfoBox
      header="Device Scan"
      subtitle="Latest inventory scan results"
      badge={<span className={styles.failedBadgeContent}><i />{failed} failed</span>}
      badgeProps={{ className: styles.failedBadge }}
      className={styles.scanCard}
      // loading={loading}
    >
      <div className={styles.scanContent}>
        <div
          className={styles.scanDonut}
          aria-label={`${percent}% scan success`}
        >
          <DonutChart
            data={[
              { id: "Success", label: "Success", value: success, color: "#B0D062" },
              { id: "Failed", label: "Failed", value: failed, color: "#fee2df" },
            ]}
            size="12.8rem"
            thickness={0.24}
            centerText={`${percent}% Success`}
            // centerText={<span><strong>{percent}%</strong><br/><small>success</small></span>}
            centerTextProps={{ className: styles.scanDonutCenter, style: { width: "auto" } }}
          />
        </div>
        <StatTiles
          columns={1}
          className={styles.scanCounts}
          loading={loading}
          items={[
            {
              id: "success",
              value: success.toLocaleString(),
              label: "Success",
              color: "#B0D062",
            },
            {
              id: "failed",
              value: failed.toLocaleString(),
              label: "Failed",
              color: "#e52b20",
            },
          ]}
        />
      </div>
      <div className={styles.failedScansHeader}>
        <span>Failed scans</span>
        <button type="button" onClick={onViewAll}>View all</button>
      </div>
      {failedScans.length ? (
        <div className={styles.failedScansList}>
          {failedScans.map((scan, index) => (
            <div key={scan.id || `${scan.deviceName}-${index}`} className={styles.failedScan}>
              <div><strong>{scan.deviceName}</strong><span>{scan.remarks}</span></div>
              <time>{scan.lastActionTime}</time>
            </div>
          ))}
        </div>
      ) : <div className={styles.failedScansEmpty}>No failed scans detected.</div>}
    </InfoBox>
  );
};

export default DeviceScanSummary;
